import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    MenuItem,
    useDisclosure,
} from '@chakra-ui/react';
import { createRef } from 'react';

export interface IEndgameProps {
    onConfirm: () => void;
}

export function EndGame(props: IEndgameProps) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const cancelRef = createRef<HTMLButtonElement>();

    return (
        <>
            <MenuItem color="red.500" onClick={onOpen}>
                Vzdát hru
            </MenuItem>
            <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
                <AlertDialogOverlay>
                    <AlertDialogContent color="gray.200">
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Vzdát hru
                        </AlertDialogHeader>

                        <AlertDialogBody>Opravdu chcete vzdát hru? Tato akce je nevratná!</AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Pokračovat ve hře
                            </Button>
                            <Button
                                colorScheme="red"
                                onClick={() => {
                                    onClose();
                                    props.onConfirm();
                                }}
                                ml={3}
                            >
                                Vzdát hru
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    );
}
